import tippy from "tippy.js";

$ ->
  if $('#js-presses, #js-preview_drafts').length > 0
    # 最後のパーツにクラスを付与
    $('.js-parts:last').addClass('p-presses-show__part-content--last')

    # ホテル比較表
    tippy '.js-popover',
      arrow: true
      animation: 'shift-away'
      delay: 300
      placement: 'bottom'
      trigger: 'click'
      theme: 'light'
